import { QueryFactory } from "../../../../Common";
export const QGetEventsByEventIdOrByLeagueId = QueryFactory("GetEventsByEventIdOrByLeagueId");
//# sourceMappingURL=QGetEventsByEventIdOrByLeagueId.js.map